import { isItemGroup } from './utils';
function matchesString(value, lowerCaseSearchText) {
    if (!value) {
        return false;
    }
    return value.toLowerCase().indexOf(lowerCaseSearchText) > -1;
}
function matchesItem(item, searchText) {
    return (matchesString(item.text, searchText) ||
        matchesString(item.secondaryText, searchText) ||
        matchesString(item.labelTag, searchText));
}
export function filterItems(items, filterText) {
    const lowerCaseSearchText = filterText.toLowerCase();
    return items.reduce((acc, item) => {
        if (!isItemGroup(item)) {
            if (matchesItem(item, lowerCaseSearchText)) {
                acc.push(item);
            }
            return acc;
        }
        // Filtered results are rendered as a collapsed (flat) list, so nested
        // groups would otherwise render a header per level. Flatten all matching
        // descendants into the top-most group and keep only its header.
        const matchingChildren = collectMatchingLeaves(item.items, lowerCaseSearchText);
        if (matchingChildren.length > 0) {
            acc.push({ ...item, items: matchingChildren });
        }
        return acc;
    }, []);
}
function collectMatchingLeaves(items, searchText) {
    return items.reduce((acc, item) => {
        if (isItemGroup(item)) {
            acc.push(...collectMatchingLeaves(item.items, searchText));
        }
        else if (matchesItem(item, searchText)) {
            acc.push(item);
        }
        return acc;
    }, []);
}
export function countLeafItems(items) {
    let count = 0;
    for (const item of items) {
        if (isItemGroup(item)) {
            count += countLeafItems(item.items);
        }
        else {
            count++;
        }
    }
    return count;
}
//# sourceMappingURL=filter-items.js.map